module.exports = __webpack_public_path__ + "media/images/lp/1/achievement2-pc-50e72cc037bc02d9886f5910cb227cd4.png";